import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import LeftPanel from '../LeftPanel/LeftPanel';
import MobileHeader from '../MobileHeader/MobileHeader';
import styles from './Layout.module.css';

export default function Layout() {
  const { pathname } = useLocation();

  const stepMap = { '/': 1, '/endereco': 2, '/simulacao': 3 };
  const currentStep = stepMap[pathname] ?? 1;

  return (
    <div className={styles.app}>
      {/* Desktop: left decorative panel */}
      <LeftPanel />

      {/* Mobile: sticky top bar with logo */}
      <MobileHeader />

      {/* Right: form area */}
      <main className={styles.right}>
        <div className={styles.inner}>
          <Outlet context={{ currentStep }} />
        </div>
      </main>
    </div>
  );
}
